import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const timesheetList = (request) =>{ // CREW BASED TIMESHEET API 
    let ENDPOINT = '';  
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        // ENDPOINT = URL_BASE_API+'events/get-time-sheet-data/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr; 
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-crew-new/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr; 

        // {eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected} 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds; 

        if(filtersData.in_out >= 0 && filtersData.selectedFromDate && filtersData.selectedFromDate.length && filtersData.selectedToDate && filtersData.selectedToDate.length) {
            ENDPOINT += '&in_out='+filtersData.in_out+'&from_date='+encodeURIComponent(filtersData.selectedFromDate)+'&to_date='+encodeURIComponent(filtersData.selectedToDate); 
        }

        let selHoursType = 0; 
        if(filtersData.selHoursType && filtersData.selHoursType.length)  selHoursType = filtersData.selHoursType; 
        let startTime = 0; 
        if(filtersData.startTime && filtersData.startTime.length)  startTime = filtersData.startTime; 
        let endTime = 0; 
        if(filtersData.endTime && filtersData.endTime.length && parseFloat(filtersData.endTime) > 0)  endTime = filtersData.endTime; 

        if(selHoursType)  ENDPOINT += '&hour_type='+selHoursType; 

        if(startTime && endTime)  ENDPOINT += '&range_type=between&hour_from='+startTime+'&hour_to='+endTime; 
        else if(startTime && !endTime)   ENDPOINT += '&range_type=greater&hour='+startTime;
        else if(!startTime && endTime)   ENDPOINT += '&range_type=lesser&hour='+endTime;

                if(filtersData.crewId){
            ENDPOINT +='&crew_filter_id='+filtersData.crewId;
        }
        if(filtersData.locationId){
            ENDPOINT +='&location_id='+filtersData.locationId;
        }
        if(filtersData.skillIds){
            ENDPOINT +='&skill_ids='+JSON.stringify(filtersData.skillIds);
        }
        if(filtersData.departmentIds){
            ENDPOINT +='&department_ids='+JSON.stringify(filtersData.departmentIds);
        }
        if(filtersData.shiftFromDate){
            ENDPOINT +='&shift_start_date='+filtersData.shiftFromDate;
        }
        if(filtersData.shiftEndDate){
            ENDPOINT +='&shift_end_date='+filtersData.shiftEndDate;
        }
    }
    else {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        // ENDPOINT = URL_BASE_API+'events/get-time-sheet-data/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr;    
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-crew-new/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr;    
    }
    return service.get(ENDPOINT);
}

export const timesheetDetails =(request) =>{  
    let ENDPOINT = '';  
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {  
        let actionNeeded  = request.data.actionNeeded;  
        let crew_profile_id = request.data.crewId; 
        // ENDPOINT = URL_BASE_API+'events/get-time-sheet-data/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr; 
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-crew-details/?crew_profile_id='+crew_profile_id+'&column=-event__id&action_needed='+actionNeeded; 

        // {eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected} 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds; 

        if(filtersData.in_out >= 0 && filtersData.selectedFromDate && filtersData.selectedFromDate.length && filtersData.selectedToDate && filtersData.selectedToDate.length) {
            ENDPOINT += '&in_out='+filtersData.in_out+'&from_date='+encodeURIComponent(filtersData.selectedFromDate)+'&to_date='+encodeURIComponent(filtersData.selectedToDate); 
        }

        let selHoursType = 0; 
        if(filtersData.selHoursType && filtersData.selHoursType.length)  selHoursType = filtersData.selHoursType; 
        let startTime = 0; 
        if(filtersData.startTime && filtersData.startTime.length)  startTime = filtersData.startTime; 
        let endTime = 0; 
        if(filtersData.endTime && filtersData.endTime.length  && parseFloat(filtersData.endTime) > 0)  endTime = filtersData.endTime; 

        if(selHoursType)  ENDPOINT += '&hour_type='+selHoursType; 

        if(startTime && endTime)  ENDPOINT += '&range_type=between&hour_from='+startTime+'&hour_to='+endTime; 
        else if(startTime && !endTime)   ENDPOINT += '&range_type=greater&hour='+startTime;
        else if(!startTime && endTime)   ENDPOINT += '&range_type=lesser&hour='+endTime;

                if(filtersData.crewId){
            ENDPOINT +='&crew_filter_id='+filtersData.crewId;
        }
        if(filtersData.locationId){
            ENDPOINT +='&location_id='+filtersData.locationId;
        }
        if(filtersData.skillIds){
            ENDPOINT +='&skill_ids='+JSON.stringify(filtersData.skillIds);
        }
        if(filtersData.departmentIds){
            ENDPOINT +='&department_ids='+JSON.stringify(filtersData.departmentIds);
        }
        if(filtersData.shiftFromDate){
            ENDPOINT +='&shift_start_date='+filtersData.shiftFromDate;
        }
        if(filtersData.shiftEndDate){
            ENDPOINT +='&shift_end_date='+filtersData.shiftEndDate;
        }
    }
    else {  
        let actionNeeded  = request.data.actionNeeded;  
        let crew_profile_id = request.data.crewId; 
        // ENDPOINT = URL_BASE_API+'events/get-time-sheet-data/?column=-event__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr;    
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-crew-details/?crew_profile_id='+crew_profile_id+'&column=-event__id&action_needed='+actionNeeded;    
    }
    return service.get(ENDPOINT);
}

export const timesheetUpdate =(request) =>{  
    let timesheetId   = request.data.id;
    const ENDPOINT = URL_BASE_API+'events/update-time-sheet/'+timesheetId;
    delete request.data.id;
    return service.put(ENDPOINT,request.data);
}

export const timesheetFilterEvents =(request) =>{  
    let ENDPOINT = URL_BASE_API+'events/timesheet-filter-events/'; 
    if(request.data.affiliateIds && request.data.affiliateIds.length) { // IF THIS IS CALLED FROM CLIENT LOGIN 
        let affiliateIds = JSON.stringify(request.data.affiliateIds);
        ENDPOINT = URL_BASE_API+'events/event-filter-events/?affiliates='+affiliateIds; 
    } 
    return service.get(ENDPOINT);
}

export const timesheetFilterLocations =(request) =>{  
    let ENDPOINT = URL_BASE_API+'events/timesheet-filter-locations/'; 
    return service.get(ENDPOINT);
}

export const timesheetFilterCrews =(request) =>{  
    let ENDPOINT = URL_BASE_API+'events/timesheet-filter-crews/'; 
    return service.get(ENDPOINT);
}
export const timesheetFilterDepartments =(request) =>{  
    let ENDPOINT = URL_BASE_API+'events/timesheet-filter-departments/'; 
    return service.get(ENDPOINT);
}
export const timesheetFilterSkills =(request) =>{  
    let ENDPOINT = URL_BASE_API+'events/timesheet-filter-skills/'; 
    return service.get(ENDPOINT);
}

export const timesheetShiftList =(request) =>{  // SHIFT BASED TIMESHEET API 
    let crew_id = request.data.crew_id;
    console.log('crew_id : ', crew_id);
    let ENDPOINT = '';
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-shift/?column=-shift__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr+'&crew_id='+crew_id; 

        // {eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected} 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds; 

        if(filtersData.in_out >= 0 && filtersData.selectedFromDate && filtersData.selectedFromDate.length && filtersData.selectedToDate && filtersData.selectedToDate.length) {
            ENDPOINT += '&in_out='+filtersData.in_out+'&from_date='+encodeURIComponent(filtersData.selectedFromDate)+'&to_date='+encodeURIComponent(filtersData.selectedToDate); 
        }

        let selHoursType = 0; 
        if(filtersData.selHoursType && filtersData.selHoursType.length)  selHoursType = filtersData.selHoursType; 
        let startTime = 0; 
        if(filtersData.startTime && filtersData.startTime.length)  startTime = filtersData.startTime; 
        let endTime = 0; 
        if(filtersData.endTime && filtersData.endTime.length)  endTime = filtersData.endTime; 
        if(parseFloat(filtersData.endTime) > 0)  endTime = filtersData.endTime; 

        if(selHoursType)  ENDPOINT += '&hour_type='+selHoursType; 

        if(parseFloat(startTime) > 0 && parseFloat(endTime) > 0)  ENDPOINT += '&range_type=between&hour_from='+startTime+'&hour_to='+endTime; 
        else if(parseFloat(startTime) > 0)   ENDPOINT += '&range_type=greater&hour='+startTime;
        else if(parseFloat(endTime) > 0)   ENDPOINT += '&range_type=lesser&hour='+endTime;

        if(filtersData.crewId){
            ENDPOINT +='&crew_filter_id='+filtersData.crewId;
        }
        if(filtersData.locationId){
            ENDPOINT +='&location_id='+filtersData.locationId;
        }
        if(filtersData.skillIds){
            ENDPOINT +='&skill_ids='+JSON.stringify(filtersData.skillIds);
        }
        if(filtersData.departmentIds){
            ENDPOINT +='&department_ids='+JSON.stringify(filtersData.departmentIds);
        }
        if(filtersData.shiftFromDate){
            ENDPOINT +='&shift_start_date='+filtersData.shiftFromDate;
        }
        if(filtersData.shiftEndDate){
            ENDPOINT +='&shift_end_date='+filtersData.shiftEndDate;
        }
    }
    else {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/get-time-sheet-data-shift/?column=-shift__id&sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&action_needed='+actionNeeded+'&search='+searchStr+'&crew_id='+crew_id;
    }
    return service.get(ENDPOINT);
}

export const timesheetCSVDownload =(request) =>{  // SHIFT BASED TIMESHEET API 
    let ENDPOINT = '';  
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        // let page   = request.data.page;
        // let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/download-time-sheet-data-shift/?column=-shift__id&sort_by='+sortBy+'&action_needed='+actionNeeded+'&search='+searchStr; 

        // {eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected} 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds; 

        if(filtersData.in_out >= 0 && filtersData.selectedFromDate && filtersData.selectedFromDate.length && filtersData.selectedToDate && filtersData.selectedToDate.length) {
            ENDPOINT += '&in_out='+filtersData.in_out+'&from_date='+encodeURIComponent(filtersData.selectedFromDate)+'&to_date='+encodeURIComponent(filtersData.selectedToDate); 
        }

        let selHoursType = 0; 
        if(filtersData.selHoursType && filtersData.selHoursType.length)  selHoursType = filtersData.selHoursType; 
        let startTime = 0; 
        if(filtersData.startTime && filtersData.startTime.length)  startTime = filtersData.startTime; 
        let endTime = 0; 
        if(filtersData.endTime && filtersData.endTime.length  && parseFloat(filtersData.endTime) > 0)  endTime = filtersData.endTime; 

        if(selHoursType)  ENDPOINT += '&hour_type='+selHoursType; 

        if(startTime && endTime)  ENDPOINT += '&range_type=between&hour_from='+startTime+'&hour_to='+endTime; 
        else if(startTime && !endTime)   ENDPOINT += '&range_type=greater&hour='+startTime;
        else if(!startTime && endTime)   ENDPOINT += '&range_type=lesser&hour='+endTime;

        if(filtersData.crewId){
            ENDPOINT +='&crew_filter_id='+filtersData.crewId;
        }
        if(filtersData.locationId){
            ENDPOINT +='&location_id='+filtersData.locationId;
        }
        if(filtersData.skillIds){
            ENDPOINT +='&skill_ids='+JSON.stringify(filtersData.skillIds);
        }
        if(filtersData.departmentIds){
            ENDPOINT +='&department_ids='+JSON.stringify(filtersData.departmentIds);
        }
        if(filtersData.shiftFromDate){
            ENDPOINT +='&shift_start_date='+filtersData.shiftFromDate;
        }
        if(filtersData.shiftEndDate){
            ENDPOINT +='&shift_end_date='+filtersData.shiftEndDate;
        }
    }
    else {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/download-time-sheet-data-shift/?column=-shift__id&sort_by='+sortBy+'&action_needed='+actionNeeded+'&search='+searchStr;    
    }
    if(request.data.crewBased){
        ENDPOINT +='&crew_based=true';
    }
    return service.get(ENDPOINT);
}

export const timesheetSummaryCSVDownload =(request) =>{  // SHIFT BASED TIMESHEET API 
    let ENDPOINT = '';  
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        // let page   = request.data.page;
        // let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/download-time-sheet-summary-data/?column=-shift__id&sort_by='+sortBy+'&action_needed='+actionNeeded+'&search='+searchStr; 

        // {eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected} 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds; 

        if(filtersData.in_out >= 0 && filtersData.selectedFromDate && filtersData.selectedFromDate.length && filtersData.selectedToDate && filtersData.selectedToDate.length) {
            ENDPOINT += '&in_out='+filtersData.in_out+'&from_date='+encodeURIComponent(filtersData.selectedFromDate)+'&to_date='+encodeURIComponent(filtersData.selectedToDate); 
        }

        let selHoursType = 0; 
        if(filtersData.selHoursType && filtersData.selHoursType.length)  selHoursType = filtersData.selHoursType; 
        let startTime = 0; 
        if(filtersData.startTime && filtersData.startTime.length)  startTime = filtersData.startTime; 
        let endTime = 0; 
        if(filtersData.endTime && filtersData.endTime.length  && parseFloat(filtersData.endTime) > 0)  endTime = filtersData.endTime; 

        if(selHoursType)  ENDPOINT += '&hour_type='+selHoursType; 

        if(startTime && endTime)  ENDPOINT += '&range_type=between&hour_from='+startTime+'&hour_to='+endTime; 
        else if(startTime && !endTime)   ENDPOINT += '&range_type=greater&hour='+startTime;
        else if(!startTime && endTime)   ENDPOINT += '&range_type=lesser&hour='+endTime;

        if(filtersData.crewId){
            ENDPOINT +='&crew_filter_id='+filtersData.crewId;
        }
        if(filtersData.locationId){
            ENDPOINT +='&location_id='+filtersData.locationId;
        }
        if(filtersData.skillIds){
            ENDPOINT +='&skill_ids='+JSON.stringify(filtersData.skillIds);
        }
        if(filtersData.departmentIds){
            ENDPOINT +='&department_ids='+JSON.stringify(filtersData.departmentIds);
        }
        if(filtersData.shiftFromDate){
            ENDPOINT +='&shift_start_date='+filtersData.shiftFromDate;
        }
        if(filtersData.shiftEndDate){
            ENDPOINT +='&shift_end_date='+filtersData.shiftEndDate;
        }
    }
    else {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy;   
        let actionNeeded  = request.data.actionNeeded;  
        let searchStr = request.data.search.length?request.data.search:''; 
        ENDPOINT = URL_BASE_API+'events/download-time-sheet-summary-data/?column=-shift__id&sort_by='+sortBy+'&action_needed='+actionNeeded+'&search='+searchStr;    
    }
    if(request.data.crewBased){
        ENDPOINT +='&crew_based=true';
    }
    return service.get(ENDPOINT);
}
